import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export default class LatestColorAPI {
    public static async getAll() {
        let colors;

        try {
            colors = (await ApiController.get(ApiRoutes.latestColors.get)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(colors);
    }

    public static async createNew(data: any) {
        let colors;

        const request: any = {
            data: {
                type: 'chosen_colors',
                attributes: {},
                relationships: {},
            },
        };

        if (data.powderId) {
            request.data.relationships.powder = {
                data: {
                    type: 'powders',
                    id: data.powderId,
                },
            };
        }

        if (data.colorId) {
            request.data.relationships.color = {
                data: {
                    type: 'colors',
                    id: data.colorId,
                },
            };
        }

        try {
            colors = (await ApiController.post(ApiRoutes.latestColors.get, request)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(colors);
    }
}
